export const organizationConstants = {
  CAN_ACCESS_CREATE_PAGE_REQUEST: 'ORGANIZATION/CAN_ACCESS_CREATE_PAGE_REQUEST',
  CAN_ACCESS_CREATE_PAGE_SUCCESS: 'ORGANIZATION/CAN_ACCESS_CREATE_PAGE_SUCCESS',
  CAN_ACCESS_CREATE_PAGE_FAILURE: 'ORGANIZATION/CAN_ACCESS_CREATE_PAGE_FAILURE',

  CAN_ACCESS_LIST_PAGE_REQUEST: 'ORGANIZATION/CAN_ACCESS_LIST_PAGE_REQUEST',
  CAN_ACCESS_LIST_PAGE_SUCCESS: 'ORGANIZATION/CAN_ACCESS_LIST_PAGE_SUCCESS',
  CAN_ACCESS_LIST_PAGE_FAILURE: 'ORGANIZATION/CAN_ACCESS_LIST_PAGE_FAILURE',

  CAN_ACCESS_INDEX_PAGE_REQUEST: 'ORGANIZATION/CAN_ACCESS_INDEX_PAGE_REQUEST',
  CAN_ACCESS_INDEX_PAGE_SUCCESS: 'ORGANIZATION/CAN_ACCESS_INDEX_PAGE_SUCCESS',
  CAN_ACCESS_INDEX_PAGE_FAILURE: 'ORGANIZATION/CAN_ACCESS_INDEX_PAGE_FAILURE',

  CREATE_ORGA_REQUEST: 'ORGANIZATION/CREATE_ORGA_REQUEST',
  CREATE_ORGA_SUCCESS: 'ORGANIZATION/CREATE_ORGA_SUCCESS',
  CREATE_ORGA_FAILURE: 'ORGANIZATION/CREATE_ORGA_FAILURE',

  DELETE_ORGA_REQUEST: 'ORGANIZATION/DELETE_ORGA_REQUEST',
  DELETE_ORGA_SUCCESS: 'ORGANIZATION/DELETE_ORGA_SUCCESS',
  DELETE_ORGA_FAILURE: 'ORGANIZATION/DELETE_ORGA_FAILURE',

  LIST_ORGA_REQUEST: 'ORGANIZATION/LIST_ORGA_REQUEST',
  LIST_ORGA_SUCCESS: 'ORGANIZATION/LIST_ORGA_SUCCESS',
  LIST_ORGA_FAILURE: 'ORGANIZATION/LIST_ORGA_FAILURE',

  LIST_WORKPLACE_REQUEST: 'ORGANIZATION/LIST_WORKPLACE_REQUEST',
  LIST_WORKPLACE_SUCCESS: 'ORGANIZATION/LIST_WORKPLACE_SUCCESS',
  LIST_WORKPLACE_FAILURE: 'ORGANIZATION/LIST_WORKPLACE_FAILURE',

  GET_USERS_REQUEST: 'ORGANIZATION/GET_USERS_REQUEST',
  GET_USERS_SUCCESS: 'ORGANIZATION/GET_USERS_SUCCESS',
  GET_USERS_FAILURE: 'ORGANIZATION/GET_USERS_FAILURE',

  GET_ORGANIZATION_REQUEST: 'ORGANIZATION/GET_ORGANIZATION_REQUEST',
  GET_ORGANIZATION_SUCCESS: 'ORGANIZATION/GET_ORGANIZATION_SUCCESS',
  GET_ORGANIZATION_FAILURE: 'ORGANIZATION/GET_ORGANIZATION_FAILURE',

  SET_CURRENT_ORGANIZATION_ID: 'ORGANIZATION/SET_CURRENT_ORGANIZATION_ID',

  SWITCH_ORGANIZATION_REQUEST: 'ORGANIZATION/SWITCH_ORGANIZATION_REQUEST',
  SWITCH_ORGANIZATION_SUCCESS: 'ORGANIZATION/SWITCH_ORGANIZATION_SUCCESS',
  SWITCH_ORGANIZATION_FAILURE: 'ORGANIZATION/SWITCH_ORGANIZATION_FAILURE',

  GET_MEMBER_DIRECTORY_REQUEST: 'ORGANIZATION/GET_MEMBER_DIRECTORY_REQUEST',
  GET_MEMBER_DIRECTORY_SUCCESS: 'ORGANIZATION/GET_MEMBER_DIRECTORY_SUCCESS',
  GET_MEMBER_DIRECTORY_FAILURE: 'ORGANIZATION/GET_MEMBER_DIRECTORY_FAILURE',

  GET_NOTIFICATIONS_REQUEST: 'ORGANIZATION/GET_NOTIFICATIONS_REQUEST',
  GET_NOTIFICATIONS_SUCCESS: 'ORGANIZATION/GET_NOTIFICATIONS_SUCCESS',
  GET_NOTIFICATIONS_FAILURE: 'ORGANIZATION/GET_NOTIFICATIONS_FAILURE',

  MARK_NOTIFICATIONS_READ_REQUEST: 'ORGANIZATION/MARK_NOTIFICATIONS_READ_REQUEST',
  MARK_NOTIFICATIONS_READ_SUCCESS: 'ORGANIZATION/MARK_NOTIFICATIONS_READ_SUCCESS',
  MARK_NOTIFICATIONS_READ_FAILURE: 'ORGANIZATION/MARK_NOTIFICATIONS_READ_FAILURE',

  SET_NATIVE_CURRENT_ORGANIZATION: 'ORGANIZATION/SET_NATIVE_CURRENT_ORGANIZATION',

  GET_HEADER_REQUEST: 'ORGANIZATION/GET_HEADER_REQUEST',
  GET_HEADER_SUCCESS: 'ORGANIZATION/GET_HEADER_SUCCESS',
  GET_HEADER_FAILURE: 'ORGANIZATION/GET_HEADER_FAILURE',

  NOTIFICATION_TEMPORARY_MUTE_REQUEST: 'ORGANIZATION/NOTIFICATION_TEMPORARY_MUTE_REQUEST',
  NOTIFICATION_TEMPORARY_MUTE_SUCCESS: 'ORGANIZATION/NOTIFICATION_TEMPORARY_MUTE_SUCCESS',
  NOTIFICATION_TEMPORARY_MUTE_FAILURE: 'ORGANIZATION/NOTIFICATION_TEMPORARY_MUTE_FAILURE',

  NOTIFICATION_TEMPORARY_UNMUTE_REQUEST: 'ORGANIZATION/NOTIFICATION_TEMPORARY_UNMUTE_REQUEST',
  NOTIFICATION_TEMPORARY_UNMUTE_SUCCESS: 'ORGANIZATION/NOTIFICATION_TEMPORARY_UNMUTE_SUCCESS',
  NOTIFICATION_TEMPORARY_UNMUTE_FAILURE: 'ORGANIZATION/NOTIFICATION_TEMPORARY_UNMUTE_FAILURE'
}
